import React, { useState, useEffect } from "react"

import Slider from "../shared/Slider";

const SliderWrap = ({ children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if(children && children.length){
      setShow(true)
    }
  }, [children])

  // Garante que cada filho tenha uma chave única
  const childrenWithKeys = React.Children.map(children, (child, index) => {
    if (!child) return null;
    
    const uniqueKey = child.key || `slide-${index}-${Math.random().toString(36).substr(2, 9)}`;
    
    return React.cloneElement(child, {
      key: uniqueKey,
      'data-key': uniqueKey
    });
  });

  if (!show || !childrenWithKeys || childrenWithKeys.length === 0) {
    return null;
  }

  return (
    <Slider>{childrenWithKeys}</Slider>
  )
}

export default SliderWrap
